import styled from "styled-components";


export const BigHeadline = styled.h1`
font-size: 2.5rem;
font-weight: 500;
color: ${(props) => props.theme.text.default};
margin: 0;
`